import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';

const getBadgeColor = status => {
  switch (status) {
    case 'new':
      return 'primary';
    case 'in_progress':
      return 'success';
    default:
      return 'default';
  }
};

const StatusBadge = ({ status }) => {
  if (status) {
    return <Badge color={getBadgeColor(status.code)}>{status.name}</Badge>;
  }
  return null;
};

StatusBadge.propTypes = {
  status: PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
  }),
};

export default StatusBadge;
